module.exports = __webpack_public_path__ + "img/new-no-statistics.156c12ee.svg";